import { useState, useCallback, useMemo } from "react";
import { SLASH_COMMANDS, type SlashCommand } from "./SlashCommandPopover";

interface UseSlashCommandPopoverProps {
  editorRef: React.MutableRefObject<any>;
  slashFilter: string;
}

interface UseSlashCommandPopoverReturn {
  showSlashCommands: boolean;
  setShowSlashCommands: React.Dispatch<React.SetStateAction<boolean>>;
  slashFilter: string;
  setSlashFilter: React.Dispatch<React.SetStateAction<string>>;
  slashIndex: number;
  setSlashIndex: React.Dispatch<React.SetStateAction<number>>;
  filteredSlashCommands: SlashCommand[];
  insertSlashCommand: (cmd: SlashCommand) => void;
}

export function useSlashCommandPopoverState({
  editorRef,
}: UseSlashCommandPopoverProps): UseSlashCommandPopoverReturn {
  const [showSlashCommands, setShowSlashCommands] = useState(false);
  const [slashFilterLocal, setSlashFilter] = useState("");
  const [slashIndex, setSlashIndex] = useState(0);

  const filteredSlashCommands = useMemo(
    () =>
      SLASH_COMMANDS.filter((cmd) =>
        cmd.command.toLowerCase().startsWith(slashFilterLocal.toLowerCase()),
      ),
    [slashFilterLocal],
  );

  const insertSlashCommand = useCallback(
    (cmd: SlashCommand) => {
      editorRef.current?.clear();
      editorRef.current?.insertText(`/${cmd.command} `);
      setShowSlashCommands(false);
      editorRef.current?.focus();
    },
    [editorRef],
  );

  return {
    showSlashCommands,
    setShowSlashCommands,
    slashFilter: slashFilterLocal,
    setSlashFilter,
    slashIndex,
    setSlashIndex,
    filteredSlashCommands,
    insertSlashCommand,
  };
}
